export default __webpack_public_path__ + "static/media/delete-file-icon.bb76bee6.svg";